import axios from "axios";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";
import { HubConnectionBuilder, JsonHubProtocol } from "@microsoft/signalr";

const PassageControlService = (props) => {
  const { t } = useTranslation();
  const [passages, setPassages] = useState([]);
  const [token, setToken] = useState(localStorage.getItem("JWT"));
  const activeRights = JSON.parse(localStorage.getItem("rights"));
  const userCanEditMode = activeRights.includes(
    "PassageControlService.SetPassageMode"
  );

  let link = localStorage.getItem("link");
  let hubConnection = new HubConnectionBuilder()
    .withUrl(link + "/ws/elementHub", {
      accessTokenFactory: () => token,
    })
    .withAutomaticReconnect()
    .withHubProtocol(new JsonHubProtocol())
    .build();

  hubConnection.on("PassageChanged", (jsonString) => {
    try {
      let passage = JSON.parse(jsonString);
      console.debug(
        "Received PassageChanged for Passage %s: %o",
        passage.name,
        passage
      );

      var passageId = passage.id;
      var selectedMode = passage.currentSelectedInputTriggerMode;

      var button = document.querySelector(
        'input[type="radio"][data-passageId="' +
          passageId +
          '"][data-modeId="' +
          selectedMode +
          '"]'
      );
      console.debug(
        "PassageChanged(%o) new active button: %o",
        passage,
        button
      );
      button.checked = true;

      /*
       * Hier könnte man wohl auch dann mit Reac-States arbeiten
       * D.h. ich bräuchte eine Variable  <passage, mode, active>
       * Bei den Buttons dann active = variable==true
       * Die setzte ich dann hier in der funktion und react aktualisiert von selbst
       * ????
       *
       * Aber ich bin froh, dass ich das erst mal so hin bekommen habe. Vllt dann bei der nächsten Seite.
       */
    } catch (error) {
      console.error("Error while processing Passage Changed Event", error);
    }
  });

  function loadPassages() {
    axios
      .get(link + "/api/EntryControlService/IOTriggerPassagesWithModes")
      .then((response) => {
        setPassages(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function setMode(passageId, modeId) {
    if (!userCanEditMode) {
      return;
    }
    axios
      .put(
        link +
          "/api/EntryControlService/SetPassageMode?passageId=" +
          parseInt(passageId) +
          "&mode=" +
          parseInt(modeId)
      )
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
    loadPassages();

    hubConnection.start().then((result) => {
      console.debug("Hub Connection changed %o", result);
      hubConnection.invoke("RegisterEntryControlUpdates");
    });
  }, []);

  return (
    <div className="pagewrapper-2">
      <div className="left-container-se left-part-carfinder">
        <div className="einstellungen-box" style={{ width: "50%" }}>
          <div className="box-name"> {t("passageControlService.header")}</div>
          <div style={{ overflow: "auto" }}>
            <table id="passageControlServiceTable">
              <thead>
                <th style={{ textAlign: "center" }}>
                  {t("elementeAllgemein.parkhaus")}
                </th>
                <th style={{ textAlign: "center" }}>
                  {t("passageControlService.passage")}
                </th>
                <th style={{ textAlign: "center" }}>
                  {t("elementeAllgemein.typ")}
                </th>
                <th style={{ textAlign: "center" }}>{t("allgemein.modus")}</th>
              </thead>

              <tbody>
                {passages.map((passage, i) => (
                  <tr>
                    <td>{passage.carParkName}</td>
                    <td>{passage.name}</td>
                    <td>
                      {t("passageControlService.typen." + passage.passsageType)}
                    </td>
                    <td>
                      <div class="radioButtonsAsButtons">
                        {passage.inputTriggerModes.map((mode, j) => {
                          let radioId = passage.id + "_" + mode.id;
                          return (
                            <>
                              <input
                                type="radio"
                                disabled={!userCanEditMode}
                                id={radioId}
                                name={passage.id}
                                defaultChecked={
                                  mode.id ==
                                  passage.currentSelectedInputTriggerMode
                                }
                                data-passageId={passage.id}
                                data-modeId={mode.id}
                                onClick={(e) => {
                                  setMode(passage.id, mode.id);
                                  e.preventDefault();
                                }}
                              />
                              <label for={radioId}>{mode.name}</label>
                            </>
                          );
                        })}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassageControlService;
